// MA-861 (PARENT-UX-2026-10-07 §4 Settings): Daily routine (all "Soon") is removed.
// The old link redirects to /parent/settings, carrying the search string (e.g. ?dev=1)
// as /parent/settings/kids does.
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/parent/settings/routine")({
  beforeLoad: ({ location }) => {
    throw redirect({ to: "/parent/settings", search: location.search as never, replace: true });
  },
  component: () => null,
});
